import React, { Component } from 'react';
import { BOOKING_CONFIRMATION_STEPS } from '../../constants';
//import FinalMessage from '../../components/FinalMessage/FinalMessage';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { PaymentForm } from './PaymentForm';
import { CreditCardForm } from './CreditCardForm';
import { LogoLoader } from '../../components/UI/Loader/LogoLoader';

class RedirectToWebsitePage extends Component {

    async componentDidMount() {
        var url = 'https://www.temakinho.com/pages/thank-you-page?restaurant=' + this.props.restaurantName + '&date=' + this.props.date + '&hour=' + this.props.time + '&guests=' + this.props.people + '&reservationCode=' + this.props.bookingReferenceCode;
        if (!!window.top) {
            window.top.location.replace(url);
        } else {
            window.location.replace(url);
        }
    }

    render() { return null; }
}

export const BookingFlowComponent = (props) => {
    let component = null;
    if (props.currentStep === BOOKING_CONFIRMATION_STEPS.SUCCESS) {
        // component = <FinalMessage
        //     {...props}
        // />
        component = <RedirectToWebsitePage
            {...props}
        />
    } else if (props.currentStep === BOOKING_CONFIRMATION_STEPS.NO_CREDIT_CARD) {
        component = <React.Fragment>
            <LogoLoader />
        </React.Fragment>
    } else if (props.currentStep === BOOKING_CONFIRMATION_STEPS.ERROR) {
        component = <React.Fragment>
            <p style={{ textAlign: 'center', fontSize: '24px', padding: '16px' }}>{props.fatalErrorMessage}</p>
        </React.Fragment>
    } else if (props.currentStep === BOOKING_CONFIRMATION_STEPS.PAYMENT_REQUIRED) {
        component = props.stripeInstance ?
            <StripeProvider stripe={props.stripeInstance}>
                <Elements fonts={[{
                    cssSrc: "https://fonts.googleapis.com/css?family=Londrina+Solid:300,400&display=swap"
                }]}>
                    <PaymentForm 
                        pay={props.bookingConfirmationPayment}
                        isSubmittingCard={props.isSubmittingCard}
                        paymentRequiredAmount={props.paymentRequiredAmount}
                        errorText={props.errorText}
                        translations={props.translations}
                    />
                </Elements>
            </StripeProvider>
            :
            null
    } else if (props.currentStep === BOOKING_CONFIRMATION_STEPS.CREDIT_CARD_REQUIRED) {
        component = props.stripeInstance ?
            <StripeProvider stripe={props.stripeInstance}>
                <Elements fonts={[{
                    cssSrc: "https://fonts.googleapis.com/css?family=Londrina+Solid:300,400&display=swap"
                }]}>
                    <CreditCardForm
                        pay={props.bookingConfirmationPayment}
                        isSubmittingCard={props.isSubmittingCard}
                        paymentRequiredAmount={props.paymentRequiredAmount}
                        errorText={props.errorText}
                        translations={props.translations}
                    />
                </Elements>
            </StripeProvider>
            :
            null
    }
    return (
        <div style={{ padding: '16px' }}>
            {component}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/containers/BookingFlow/BookingFlowComponent.js